import { render, staticRenderFns } from "./RiverTemp.vue?vue&type=template&id=373f534a"
import script from "./RiverTemp.vue?vue&type=script&lang=js"
export * from "./RiverTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports